import { useStaticQuery, graphql } from 'gatsby';
import styled from 'styled-components';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import React from 'react';

import cssObj from '../../../assets/css/cssObj';

const HeaderContainer = styled.nav`
    position: relative;
    align-items: center;
    background: linear-gradient(to right, #542200 10%, #57230080 90%);
    box-shadow: 0rem 0.2rem 0.3rem #4e4e4e;
    display: flex;
    height: 8rem;
    padding: 1rem;

    @media (min-width: ${cssObj.vars.xLargeBreakPoint}) {
        background: linear-gradient(#542200 10%, #54220080 90%);
        box-shadow: 0.2rem 0rem 0.3rem #4e4e4e;
        flex-direction: column;
        height: 100vh;
        justify-content: flex-start;
        padding: 2rem;
    }
`;

const StyledHeaderImg = styled(GatsbyImage)`
    border: 0.1rem #c4c4c4 solid;
    border-radius: 50%;
    height: 6rem;
    margin-right: 1rem;
    max-width: 6rem;

    @media (min-width: ${cssObj.vars.xLargeBreakPoint}) {
        height: 10rem;
        margin-right: 0;
        max-width: 10rem;
    }
`;

const HeaderContent = styled.div``;

const HeaderTitle = styled.h1`
    color: #ffffff;
    font-family: ${cssObj.vars.nunitoSans};
    font-size: 1.35rem;
    font-weight: 700;
    margin: 0 0 0.5rem 0;

    @media (min-width: ${cssObj.vars.smallBreakPoint}) {
        font-size: 1.7rem;
    }

    @media (min-width: ${cssObj.vars.xLargeBreakPoint}) {
        font-size: 2rem;
        margin-top: 1rem;
        text-align: center;
    }
`;

const HeaderSummary = styled.div`
    border-top: 0.2rem solid ${cssObj.vars.teal};
    color: #ffffff;
    font-family: ${cssObj.vars.nunitoSans};
    font-size: 0.75rem;
    padding-top: 0.5rem;

    @media (min-width: ${cssObj.vars.smallBreakPoint}) {
        font-size: 0.85rem;
    }
`;

const titleAndImgQuery = graphql`
    query {
        placeholderImage: file(relativePath: { eq: "personal/illustrated_portrait.jpeg" }) {
            childImageSharp {
                gatsbyImageData(layout: CONSTRAINED, width: 300)
            }
        }
        site {
            siteMetadata {
                title
            }
        }
    }
`;

const Header = () => {
    const data = useStaticQuery(titleAndImgQuery);
    const image = getImage(data.placeholderImage);

    return (
        <HeaderContainer>
            <StyledHeaderImg image={image} alt="Illustrated portrait of Geoff George" />
            <HeaderContent>
                <HeaderTitle>{data.site.siteMetadata.title}</HeaderTitle>
                <HeaderSummary>Software Engineer / Writer / Editor</HeaderSummary>
            </HeaderContent>
        </HeaderContainer>
    );
};

export default Header;
